export { default as DynamicModal } from "./DynamicModal";
export { default as ModalLayout } from "./ModalLayout";

export { default as PhoneInputStep } from "./steps/PhoneInputStep";
export { default as OTPVerificationStep } from "./steps/OTPVerificationStep";
export { default as CustomerInfoStep } from "./steps/CustomerInfoStep";
export { default as TripDurationStep } from "./steps/TripDurationStep";
export { default as SuccessStep } from "./steps/SuccessStep";

export {
  talkToExpertFlow,
  loginFlow,
  leadFlow,
  leadFlowSkippable,
} from "./flows";

export type {
  ModalFlow,
  ModalStep,
  ModalStepProps,
  DynamicModalProps,
  ModalData,
  ModalState,
} from "../../../types/components/modal";

export {
  phoneSchema,
  otpSchema,
  customerInfoSchema,
  tripDurationSchema,
} from "./schemas";
